<template>
  <modal v-if="isOpen" @hide-modal="hideModal" :maxWidth="'745px'" :maxHeight="'745px'">
    <template v-slot:content>
      <div class="relative w-full">
        <div class="header">
          <h1 class="text-2xl mb-0 mt-0 font-semibold">{{ globals.cmModal.title }}</h1>
          <p class="text-base mt-0 leading-tight text-blue-dark">{{ globals.cmModal.description.replace('_quantity_', currentQuantity) }}</p>
        </div>
        <hr/>
        <div v-for="cm in fullCMList" :key="cm" class="product-wrapper">
          <div v-if="(cm.key === 'CM31' && showCM31) || (cm.key === 'CM32' && showCM32)" class="flex flex-wrap justify-center">
            <div class="image-wrapper md:w-1/2 flex justify-center align-start">
              <img :src="cm.image[0]"/>
            </div>
            <div class="content-wrapper md:w-1/2">
              <h1 class="text-xl mb-0 mt-0 font-semibold">{{ cm.name }}</h1>
              <p class="text-lg mt-0 leading-tight text-blue-dark">{{ currencySymbol }}{{ calculateTotalPrice(cm.offerings[cm.defaultOffering].salesPrice) }}/{{cm.offerings[cm.defaultOffering].defaultPaymentTerm}}</p>
              <p class="text-base mt-1 text-blue-dark">{{ cm.brief }}</p>
              <div class="quantity-info-container mt-1 flex justify-start items-center">
                <p class="text-base font-semibold mr-1 text-blue-dark mt-0 ml-0">Select Quantity</p>
                <QuantityToggle
                  ref="selectedQuantity"
                  :max="currentQuantity - (cm.key === 'CM31' ? CM32Quantity : CM31Quantity)"
                  :min="0"
                  :default="0"
                  :productKeyOverride="cm.key"
                  @setProductQuantity="setQuantity($event, cm.key)"
                />
              </div>
            </div>
          </div>
          <hr/>
        </div>
        <div class="footer-wrapper flex justify-end pt-1 md:pt-2 md:pr-3">
          <h3 class="text-lg md:text-xl blue-text mr-1 cursor-pointer" @click="handleSkipAddOnsClick">Skip add-ons</h3>
          <vButton
            position="center"
            mobile="12"
            tablet="12"
            desktop="12"
            styling="primary rounded text-lg md:text-xl"
            wrapperStyling="!ml-1/2 !mt-0 !mb-0"
            height="42px"
            :disabled="disabled"
            @onClickEvent="handleSubmit"
          >
            <template v-slot:content>
              {{ submitButtonText }}
            </template>
          </vButton>
        </div>
      </div>
    </template>
  </modal>
</template>
<style lang="scss" scoped>
  .header {
    padding: 18px 43px;
    height: fit-content;
  }
  .footer-wrapper {
    position: sticky;
    padding-bottom: 15px;
    bottom: -15px;
    left: 0;
    background-color: white;
  }
  hr {
    border: -1px solid #E7EAEE;
    width: 103%;
    position: relative;
    margin-left: -1.5%;
  }
  img {
    max-width: 250px;
    height: fit-content;
  }
  .content-wrapper {
    padding: 44px 0;
    padding-right: 50px;
  }
  @media (max-width: 736px) {
    .header {
      padding: 18px 12px;
    }
    .content-wrapper {
      padding: 20px;
      padding-top: 0;
    }
  }
</style>
<script>
import modal from '../../../utils/modal.vue';
import vButton from "../../../utils/button";
import QuantityToggle from '../../../utils/quantity-toggle';
import { mapGetters, mapMutations } from "vuex";
import { WebstoreResources } from "../../../../mixins/webstore-resources"
import SalesforceResources from "../../../../mixins/salesforce-resources";
import SegmentResources from "../../../../mixins/segment-resources";

export default {
  mixins: [
    WebstoreResources,
    SalesforceResources,
    SegmentResources,
  ],
  components: {
    modal,
    vButton,
    QuantityToggle,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    showCM31: {
      type: Boolean,
      default: true
    },
    showCM32: {
      type: Boolean,
      default: true
    },
    globals: {
      type: Object,
      default: {}
    },
  },
  data() { 
    return {
      disabled: true,
      totalQuantity: 0,
      CM31Quantity: 0,
      CM32Quantity: 0,
    }
  },
  computed: {
    ...mapGetters([
      "currencySymbol",
      "productCatalog",
      "activeProductInfo",
      "activeProductKey",
      "activeOfferKey",
    ]),
    ...mapGetters("content", [
      "webstoreContent",
    ]),
    currentQuantity() {
      return this.$store.getters[
        `${this.activeProductKey}/quantity`
      ];
    },
    fullCMList() {
      return [this.productCatalog['CM']['CM31'], this.productCatalog['CM']['CM32']];
    },
    totalQuantity() {
      return this.CM31Quantity + this.CM32Quantity;
    },
    submitButtonText() {
      return this.existingOfferInCart
        ? this.webstoreContent.selectProductsPage.update_bag
        : this.webstoreContent.addToBag;
    },
  },
  methods: {
    ...mapMutations([
      "setShoppingCartToOpened",
    ]),
    hideModal() {
      this.$emit("hide-modal");
      this.productAddedToCart();
    },
    handleSubmit() {
      if (this.CM31Quantity > 0) {
        this.$emit("cm-add-to-cart", this.productCatalog['CM']['CM31'].offerings['Add-on License + Hardware']);
      }
      if (this.CM32Quantity > 0) {
        this.$emit("cm-add-to-cart", this.productCatalog['CM']['CM32'].offerings['Add-on License + Hardware']);
      }
      this.trackUpdateBagClick();
      this.hideModal();
    },
    handleSkipAddOnsClick() {
      this.fireSegmentTrackingWithSfdcSegments("Skip Add-Ons Clicked", this.sfdcSegments);
      this.hideModal();
    },
    setQuantity(event, type) {
      this[`${type}Quantity`] = event;
      this.totalQuantity = this.CM31Quantity + this.CM32Quantity;
      this.disabled = !(this.totalQuantity > 0);
    },
    trackCMModalView() {
      this.fireSegmentTrackingWithSfdcSegments("CM Cross-Sell Modal Viewed", this.sfdcSegments);
    },
    trackUpdateBagClick() {
      let properties = {
        cm31Quantity: this.CM31Quantity,
        cm32Quantity: this.CM32Quantity,
      };
      this.fireSegmentTrackingWithSfdcSegments("Update Bag Clicked", this.sfdcSegments, properties);
    }

  },
  watch: {
    isOpen: function() {
      if (this.isOpen) {
        this.trackCMModalView();
      }
    }
  }
};
</script>
